export default __webpack_public_path__ + "static/media/keys.a14e13cf.svg";